// extracted by mini-css-extract-plugin
export default {"wrapper":"CreateOrganizationPopupContent_wrapper__93xSl"};